import { CellLocation, Id, MenuOption, SelectionMode } from "@silevis/reactgrid";

export const getContextMenuOptions = ({
    selectedRanges,
    onRowsDelete,
    onRowAdd,
    defaultMenuOptions,
}: {
    selectionMode: SelectionMode;
    selectedRowIds: Array<Id>;
    selectedColIds: Array<Id>;
    defaultMenuOptions: Array<MenuOption>;
    selectedRanges: Array<Array<CellLocation>>;
    onRowsDelete: (rowIds: Array<Id>) => void;
    onRowAdd: () => void;
}): Array<MenuOption> => {
    const selectedRowIds: Array<Id> = [
        ...new Set(selectedRanges.flatMap((range) => range.map((cell) => cell.rowId))),
    ];

    return [
        ...defaultMenuOptions,

        {
            id: "deleteRows",
            label: "Delete selected rows",
            handler: (): void => {
                onRowsDelete(selectedRowIds);
            },
        },

        {
            id: "addRow",
            label: "Add row at the end",
            handler: (): void => {
                onRowAdd();
            },
        },
    ];
};
